import { Icon } from '@common/components';
import { useMutation, useNavigate } from '@common/hooks';
import { ArchiveWorkforceGroup } from '@scheduling/graphql';
import React from 'react';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { Button, Dropdown } from 'antd';
import {
  activeWorkersInfoModal,
  confirmArchiving,
} from '@scheduling/components/admin-workforce-group-archiving';

export const AdminWorkforceGroupsTableAction = ({
  recordId,
  isRecordActive,
  hasActiveWorkers,
}: {
  recordId: string;
  isRecordActive: boolean;
  hasActiveWorkers: boolean;
}) => {
  const navigate = useNavigate();

  const [archiveWorkforceGroup] = useMutation(ArchiveWorkforceGroup, {
    refetchQueries: ['WorkforceGroupsQuery'],
  });

  const items = [
    {
      key: 'view',
      label: 'View',
      onClick: () => {
        navigate(`${ORGANIZATION_ADMIN_MENU.GROUPS.ROUTE}/${recordId}/details`);
      },
    },
    {
      key: 'archive',
      label: 'Archive',
      disabled: !isRecordActive,
      onClick: () => {
        if (!isRecordActive) {
          return;
        }

        if (hasActiveWorkers) {
          activeWorkersInfoModal(recordId);
          return;
        }

        confirmArchiving(() => {
          archiveWorkforceGroup({
            variables: {
              input: {
                workforceGroupId: recordId,
              },
            },
          });
        });
      },
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button type="link">
        <Icon kind="regular" icon="verticalEllipsis" size="md" color="elm" />
      </Button>
    </Dropdown>
  );
};
